import styled, { css } from 'styled-components';

interface IContainerProps {
  isErrored: boolean;
  isFocused: boolean;
}

export const Container = styled.div<IContainerProps>`
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  position: relative;

  label {
    display: flex;
    flex-direction: row;
    color: var(--black);
    font-size: 0.9rem;
  }

  .input-and-password {
    display: flex;
    flex-direction: row;
    align-items: center;
    border-radius: 0.2rem;
  }

  input {
    width: 100%;
    height: 2.5rem;
    font-size: 0.9rem;
    padding-left: 1.4rem;
    padding-right: 2rem;
    font-weight: 500;
    background-color: var(--gray_light_light);
    border: 1px solid transparent;
    border-radius: 0.2rem;

    &::placeholder {
      color: var(--gray_medium);
    }

    &:focus {
      border-color: var(--primary_color);
    }

    ${props =>
      props.isErrored &&
      css`
        border-color: var(--red);
      `}
  }

  .password {
    cursor: pointer;
    margin: 0 1rem;

    + .input-error {
      margin-right: 2rem;
    }
  }

  &.isPassword .input-error {
    margin-right: 3rem;
  }

  .input-error {
    top: 1.8rem;
  }

  & + .input-with-label {
    margin-top: 1rem;
  }
`;
